import { ComponentProps, forwardRef } from 'react';

import { Box, Stack } from '@eneco/sparky';
import { styled } from '@eneco/sparky/stitches';

import { transformStackItemClass, batteryModuleStackItemClass } from './SmartHomeBattery.css';

export const MaxWidthBox = styled(Box, {
  maxWidth: '100%',
  width: '500px',
});

export const TransformStackItem = forwardRef<HTMLDivElement, ComponentProps<typeof Stack.Item>>(
  ({ className, ...props }, ref) => (
    <Stack.Item ref={ref} className={`${transformStackItemClass} ${className || ''}`} {...props} />
  ),
);

TransformStackItem.displayName = 'TransformStackItem';

export const BatteryModuleStackItem = forwardRef<HTMLDivElement, ComponentProps<typeof Stack.Item>>(
  ({ className, ...props }, ref) => (
    <Stack.Item ref={ref} className={`${batteryModuleStackItemClass} ${className || ''}`} {...props} />
  ),
);

BatteryModuleStackItem.displayName = 'BatteryModuleStackItem';
